/**
 * A surface registry row's label in the active locale.
 *
 * `label_msgid` carries the English SOURCE text of an existing catalogue entry
 * (every non-empty registry label is in the catalogue: surfaceLabel.test.ts
 * checks each one against the compiled Hungarian catalogue, so this lookup
 * never renders a raw id unnoticed). Lingui 5 stores an entry under
 * `generateMessageId(msgid, msgctxt)`; the registry carries no msgctxt, so the
 * context is empty. The English text rides along as the message, which is what
 * renders if an entry were ever missing.
 *
 * Used by the platform admin's Surfaces tab (surfaceLabel) and by the staff
 * marker's tooltip, which names what it marks (D-TSG-26 amendment 2026-09-30).
 *
 * @module surfaces/registryLabel
 */
import type { I18n } from "@lingui/core";
import { generateMessageId } from "@lingui/message-utils/generateMessageId";

/** The row's label in the active locale, or null when the row has none (e.g. tenant.invite). */
export function registryLabel(i18n: Pick<I18n, "_">, labelMsgid: string | undefined): string | null {
  if (!labelMsgid) return null;
  return i18n._({ id: generateMessageId(labelMsgid), message: labelMsgid });
}
